import React from 'react';
import { Container } from './styles';
import HandleArea from 'common/HandleArea';

const ChooseArea = (): JSX.Element => {
  return (
    <Container>
      <HandleArea />
    </Container>
  );
};

export default ChooseArea;
